// extracted by mini-css-extract-plugin
export default {"basicInfoContainer":"ubCfhX","userSelectionContainer":"zvrlmA","userTableContainer":"Y_iL_q","connectionsPanelsContainer":"gd2qwa","selectedAssetsPanelContainer":"kzBGI1"};